import Vue from 'vue'
import {BootstrapVue} from "bootstrap-vue";

import { LoginMixins } from "../../../secured/mixins/login-mxins";
import { NavigationMixins } from "../../../secured/mixins/nav-mixins";
import {axClient} from "../../../secured/mixins/axios-mixins";

Vue.use(BootstrapVue);

new Vue({
    el: "#app",
    mixins: [LoginMixins, NavigationMixins],
    data: {
        disableButton: false,
        username: "",
        showForm: true,
        showError: false,
        showSuccess: false,
        showMaxReached: false
    },
    methods: {
        sendForm: function() {
            let vm = this;
            vm.disableButton = true;
            vm.showError = false;

            let data = {}
            data.username = vm.username;

            axClient.post(window.location.href, data, function(rsp) {
                console.log(rsp);
                let status = rsp.status;
                if (status == 201) {
                    vm.showForm = false;
                    vm.showSuccess = true;
                } else {
                    let data = rsp.data;
                    if (data.s == 1) {
                        vm.showForm = false;
                        vm.showMaxReached = true;
                    }
                }
            }, function(rsp) {
                vm.showError = true;
                vm.disableButton = false;
            });
        }
    }
});